module.exports = __webpack_public_path__ + "img/category-brand.7d33527a.png";